<template>
  <div class="class-inf">
    <div class="ly-card search-content">
      <div class="btn-group">
        <el-button type="primary" size="medium" @click="addClass" v-if="hasPermission('my_class_create')"
          >创建班级</el-button
        >
        <el-button size="medium" @click="dialogVisible = true">显示列名</el-button>
        <advanced-class-query @search="search" />
        <el-popover :visible-arrow="false" placement="bottom" trigger="click" popper-class="popper-btn-group">
          <div class="high-search">
            <div @click="exportClass" v-if="hasPermission('batch_export_my_class')">批量导出</div>
            <el-divider v-if="hasPermission('batch_export_my_name')"></el-divider>
            <div @click="() => exportClassRoster(selection)" v-if="hasPermission('batch_export_my_name')">批量导出花名册</div>
          </div>
          <el-button slot="reference" size="medium" type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
        </el-popover>
        <drafts @create="createByDrafts" ref="drafts" />
      </div>
      <div class="search-group">
        <el-input placeholder="班级名称" v-model.trim="searchFormData.query" @keydown.native.enter="() => search()" />
        <el-button type="primary" size="medium" @click="() => search()">查询</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableConfig="tableConfig"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      class="ly-card diy-table"
      ref="lyTable"
    >
      <template v-slot:reserved_count="row">
        <span :class="countClassRes(row)">{{ `${row.reserved_sign_up_count}/${row.reserved_count}` }}</span>
      </template>
      <template v-slot:minister_sign_up_count="row">
        <span :class="countClassMin(row)">{{ `${row.minister_sign_up_count}/${globalConfig.minister_quota}` }}</span>
      </template>
      <template v-slot:countStatus="row">
        <span :class="countClass(row)">{{ row.sign_up_count }}/{{ row.class_count }}/{{ row.class_size }}</span>
      </template>
      <template v-slot:name="row">
        <el-button @click="showClass(row)" type="text" size="mini">{{ row.name }}</el-button>
      </template>
      <template v-slot:scud="row">
        <el-button @click="showSc(row)" type="text" size="mini">查看</el-button>
      </template>
      <template v-slot:org="row">
        {{ row.fee_level.org_full_name && row.fee_level.org_full_name.replace(/中国儿童中心\/+/, '') }}
      </template>
      <template v-slot:specialized="row">
        {{ row.fee_level.specialized_subject_full_name | lastName }}
      </template>
      <template v-slot:teacher="row">
        {{ row.teacher | teacherFilter }}
      </template>
      <template v-slot:class_time_sp="row">
        <div v-html="classTimeSp(row)"></div>
      </template>
      <template v-slot:class_periodic="row">
        {{ row.class_periodic | classPeriodic }}
      </template>
      <template v-slot:fee="row">
        {{ row.fee_level.name }}
      </template>
      <template v-slot:class_time="row">
        {{ `${row.first_class_start_time.split(' ')[0]} 至 ${row.last_class_end_time.split(' ')[0]}` }}
      </template>
      <template v-slot:class_size="row">
        {{ row.class_size }}
      </template>
      <template v-slot:class_status="row">
        {{ row | classStatus }}
      </template>
      <template v-slot:action="row">
        <el-dropdown trigger="click" class="dropdown-buttons">
          <span class="el-dropdown-link">菜单<i class="el-icon-arrow-down el-icon--right"></i> </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              icon="el-icon-document-copy"
              v-if="hasPermission('my_class_copy')"
              @click.native="copyClass(row)"
              >复制</el-dropdown-item
            >
            <el-dropdown-item icon="el-icon-document-checked" v-if="hasPermission('my_class_detail')" @click.native="classInf(row)">报名详情</el-dropdown-item>
            <el-dropdown-item
              icon="el-icon-edit-outline"
              @click.native="editClass(row)"
              v-if="row.class_phase !== 3 && hasPermission('my_class_edit')"
              >编辑</el-dropdown-item
            >
            <el-dropdown-item
              icon="el-icon-refresh-left"
              @click.native="revoke(row)"
              class="danger"
              v-if="row.class_phase === 1 && row.audit_status !== 1 && hasPermission('my_class_revoke')"
              >撤销</el-dropdown-item
            >
            <el-dropdown-item
              icon="el-icon-delete"
              class="danger"
              v-if="row.audit_status === 3 && hasPermission('my_class_delete')"
              @click.native="deleteClass(row)"
              >删除</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </ly-table>
    <set-table-header
      @close="dialogVisible = false"
      @change="setShowField"
      itemKey="personalclassinfhd"
      :dialogVisible="dialogVisible"
      :tableHeader="tableHeader"
      ref="setTableHd"
    ></set-table-header>
    <el-dialog title="课程表" :visible.sync="dialogVisibleSc" width="1400px">
      <class-schedule :class_mode="scTime.class_mode" :class_id="scTime.class_id" />
    </el-dialog>
    <el-dialog title="班级信息" :visible.sync="dialogVisibleDetail" width="1000px">
      <class-inf-detail-list @showSc="showSc" :defaultFormItemClass="defaultFormItemClassList"></class-inf-detail-list>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog, Dropdown, DropdownMenu, DropdownItem, Input, Popover, Divider } from 'element-ui';
import LyTable from '@/components/LyTable';
import { classApi } from '@/api';
import { classInfTable } from '@/utils/tableHeaderClass';
import pattern from '@/utils/pattern';
import SetTableHeader from '@/components/SetTableHeader';
import ClassInfDetailList from '@/components/ClassInfDetail/list';
import ClassSchedule from '@/components/ClassSchedule';
import AdvancedClassQuery from '@/components/AdvancedClassQuery';
import Drafts from '@/components/Drafts';
import classMixin from '@/utils/classMixin';
import perMixin from '@/utils/perMixin';
import localCache from '@/utils/localCache';
import utils from '@/utils/utils';

const Decimal = require('decimal.js');

export default {
  name: 'PersonClassInf',
  mixins: [classMixin, perMixin],
  components: {
    LyTable,
    ElInput: Input,
    ElDialog: Dialog,
    SetTableHeader,
    ClassInfDetailList,
    ClassSchedule,
    AdvancedClassQuery,
    ElPopover: Popover,
    Drafts,
    ElDropdown: Dropdown,
    ElDropdownMenu: DropdownMenu,
    ElDropdownItem: DropdownItem,
    ElDivider: Divider
  },
  data() {
    return {
      searchFormData: {
        query: '',
        page_no: 1,
        page_size: 10
      },
      tableConfig: {
        action: {
          'selection-change': selection => {
            this.selection = selection;
          }
        }
      },
      selection: [],
      tableHeader: [],
      getTableData: classApi.getMyClassInf,
      dialogVisible: false,
      dialogVisibleDetail: false, // 非编辑信息展示
      isCopy: false,
      defaultFormItemClass: {},
      defaultFormItemClassList: {},
      isOnlyRead: false,
      dialogVisibleSc: false,
      scTime: {} // 课程表信息
    };
  },
  mounted() {
    this.search();
    this.getHdEnum(classInfTable);
  },
  filters: {
    teacherFilter(value) {
      return (value || []).map(item => item.real_name).join(',');
    }
  },
  methods: {
    searchDrafts() {
      this.$refs.drafts.search();
    },
    openEvent() {
      this.$refs.lyForm.$refs.lyForm.clearValidate();
    },
    setShowField(data) {
      this.tableHeader = data;
    },
    async search(data) {
      this.searchFormData = { ...this.searchFormData, ...data };
      this.$refs.lyTable.setData();
    },
    setMoneyRatio() {
      this.$prompt('已选（10）', '课酬率设置', {
        confirmButtonText: '确定',
        customClass: 'percent-content',
        inputPlaceholder: '请输入小于或等于100的数字',
        cancelButtonText: '取消',
        inputPattern: pattern.decimalOne,
        inputErrorMessage: '课酬率格式不正确',
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        closeOnPressEscape: false
      })
        .then(({ value }) => {
          classApi
            .setRemuneration({
              params: {
                class_ids: this.selection.map(item => item.id),
                remuneration: Decimal.div(value, 100).toNumber()
              }
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '更新成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    showClass(row) {
      this.defaultFormItemClassList = { ...row };
      this.dialogVisibleDetail = true;
    },
    copyClass(row) {
      this.isCopy = true;
      this.isOnlyRead = false;
      this.controlClass(row);
    },
    addClass() {
      this.isCopy = false;
      this.isOnlyRead = false;
      this.controlClass({});
    },
    editClass(row) {
      this.isCopy = false;
      this.isOnlyRead = false;
      this.controlClass(row);
    },
    controlClass(row) {
      this.defaultFormItemClass = { ...row };
      // this.$refs.classInfDetail.openDg();
      localCache.setItem('CLASS_INFO', this.defaultFormItemClass);
      this.$router.push(`/${this.$route.params.user_id}/classes/create/${row.id || -1}?isCopy=${this.isCopy}`);
    },
    classInf(row) {
      const routeUrl = this.$router.resolve(
        `/${this.$route.params.user_id}/classes/enrolment/${row.id}?class_phase=${row.class_phase}&name=${row.name}&fee_level=${row.fee_level.specialized_subject_full_name}`
      );
      window.open(routeUrl.href, '_blank');
    },
    showSc(row) {
      this.dialogVisibleSc = true;
      this.scTime = {
        class_mode: row.class_mode,
        class_id: row.id
      };
    },
    revoke(row) {
      this.$confirm('确认撤销该班级?', '提示', {
        type: 'warning'
      })
        .then(() => {
          classApi
            .classRevoke({
              params: {
                class_info_ids: [row.id]
              }
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '撤销成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    deleteClass(row) {
      this.$confirm('确认删除该班级?', '提示', {
        type: 'warning'
      })
        .then(() => {
          classApi
            .controlClass({
              methold: 'DELETE',
              id: row.id
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '删除成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    createByDrafts(item) {
      this.isCopy = true;
      this.isOnlyRead = false;
      // 设置ID适应组件，走复制班级逻辑
      this.controlClass({ ...item, id: -1 });
    },
    exportClass() {
      if (!this.selection.length) {
        this.$message.warning('请选择需要导出的班级！');
        return;
      }
      classApi
        .exportMyClass({
          params: {
            class_ids: this.selection.map(item => item.id)
          }
        })
        .then(data => {
          if (data) utils.downloadData(data, '班级信息');
        });
    },
    closeAll() {
      this.$confirm('确认暂停该班级报名?', '提示', {
        type: 'warning'
      })
        .then(() => {
          classApi
            .activateClassSignClose({
              params: {
                class_info_ids: this.selection.map(item => item.id)
              }
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '关闭成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    openAll() {
      if (!this.selection.length) {
        this.$message.warning('请选择需要开启的班级！');
        return;
      }
      this.$confirm('确认开启所选班级报名?', '提示', {
        type: 'warning'
      })
        .then(() => {
          classApi
            .activateClassSignUp({
              params: {
                class_info_ids: this.selection.map(item => item.id)
              }
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '开启成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    exportClassRoster(selection) {
      if (selection && !this.selection.length) {
        this.$message.warning('请选择需要导出的班级！');
        return;
      }
      const params = {};
      if (selection) {
        params.class_ids = selection.map(item => item.id);
      }
      classApi
        .exportClassCoster({
          params
        })
        .then(data => {
          if (data) utils.downloadData(data, '花名册信息', 'xls');
        });
    }
  }
};
</script>

<style lang="less" scoped>
.search-content {
  display: flex;
  justify-content: space-between;
  .search-group .el-input {
    width: 150px;
    margin-right: 20px;
  }
}
.field-label .el-checkbox {
  min-width: 100px;
  margin-bottom: 15px;
}
</style>
<style lang="less">
.class-inf {
  .el-dialog__body {
    padding: 15px 20px;
  }
  .el-date-editor .el-range-separator {
    width: 20px;
  }
  .small-week {
    .el-radio {
      margin-right: 5px;
    }
  }
}
.dropdown-buttons {
  color: @main-blue;
}
.el-dropdown-menu .danger {
  color: @danger;
  &:hover {
    color: #f78989;
  }
}
</style>
